export enum XraysTypes {
  GET_ALL_XRAYS = "@@XRAYS/GET_ALL_XRAYS",
  SET_ALL_XRAYS = "@@XRAYS/SET_ALL_XRAYS",
  SET_ALL_XRAYS_IS_LOADING = "@@XRAYS/SET_ALL_XRAYS_IS_LOADING",
  DELETE_XRAY_START = "@@XRAYS/DELETE_XRAY_START",
  DELETE_XRAY_SUCCESS = "@@XRAYS/DELETE_XRAY_SUCCESS",
  SET_CURRENT_PAGE = "@@XRAYS/SET_CURRENT_PAGE",
}
